import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CampaignActivityLogDto} from "../../model/dto/entity/campaign-activity-log.dto";

@Injectable({
    providedIn: 'root'
})
export class CampaignActivityLogService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignActivityLogs')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-list-alt';
    }

    /**
     * Gets all activity logs for a campaign in chronological order.
     */
    getByCampaignId(campaignId: number): Observable<CampaignActivityLogDto[]> {
        return this.getGeneric<CampaignActivityLogDto[]>(`/byCampaign/${campaignId}`);
    }

    /**
     * Gets activity logs for a campaign filtered by activity type.
     */
    getByCampaignIdAndType(campaignId: number, activityType: string): Observable<CampaignActivityLogDto[]> {
        return this.getGeneric<CampaignActivityLogDto[]>(`/byCampaign/${campaignId}/byType/${activityType}`);
    }

    /**
     * Gets activity logs for a campaign filtered by multiple activity types.
     */
    getByCampaignIdAndTypes(campaignId: number, activityTypes: string[]): Observable<CampaignActivityLogDto[]> {
        const params = activityTypes.map(t => `activityTypes=${encodeURIComponent(t)}`).join('&');
        return this.getGeneric<CampaignActivityLogDto[]>(`/byCampaign/${campaignId}/byTypes?${params}`);
    }

    /**
     * Gets activity logs for a campaign within a date range.
     */
    getByCampaignIdAndDateRange(campaignId: number, startDate: Date, endDate: Date): Observable<CampaignActivityLogDto[]> {
        const startIso = startDate.toISOString();
        const endIso = endDate.toISOString();
        return this.getGeneric<CampaignActivityLogDto[]>(`/byCampaign/${campaignId}/byDateRange?startDate=${encodeURIComponent(startIso)}&endDate=${encodeURIComponent(endIso)}`);
    }

    /**
     * Gets activity logs performed by a specific user.
     */
    getByUserId(userId: number): Observable<CampaignActivityLogDto[]> {
        return this.getGeneric<CampaignActivityLogDto[]>(`/byUser/${userId}`);
    }

    /**
     * Gets activity logs for a specific target entity.
     */
    getByTargetEntity(targetEntityType: string, targetEntityId: number): Observable<CampaignActivityLogDto[]> {
        return this.getGeneric<CampaignActivityLogDto[]>(`/byTarget/${encodeURIComponent(targetEntityType)}/${targetEntityId}`);
    }
}
